import React from "react";
import { Upload, Form, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { uploadFileApi } from "../../../api/ManageApi";

const UploadImageFormItem = (props: {
  name: any;
  label: string;
  text: string;
  form: any;
  maxCount?: number;
}) => {

  return <Form.Item noStyle shouldUpdate>
    {() => {
      const fileData = (props.form.getFieldValue('upload') || {})[props.name];
      return <Form.Item
        name={["upload", props.name]}
        label={props.label}
        valuePropName={'fileList'}
        getValueFromEvent={(e:any) => {
          if (Array.isArray(e)) {
            return e;
          }
          return e?.fileList;
        }}
      >
        <Upload
          customRequest={async(options: any) => {
            const { onSuccess, onError, file } = options
            const upload_response = await uploadFileApi({file: file, type: 'article'})
            if (upload_response.status) {
              file.url = upload_response?.data?.url
              onSuccess && onSuccess(file)
            } else {
              message.error( upload_response.error )
              onError && onError({message: upload_response.error, name: 'error'})
            }
          }}
          fileList={fileData || []}
          listType="picture-card"
          maxCount={props.maxCount || 1}
          accept={'image/*'}>
          {
            (fileData || []).length < (props.maxCount || 1) && <button style={{ border: 0, background: 'none' }} type="button">
              <PlusOutlined />
              <div style={{ marginTop: 8 }}>上传</div>
            </button>
          }
        </Upload>
      </Form.Item>
    }}
  </Form.Item>;
};

export default UploadImageFormItem;